var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
export var EpicSearchSortBy;
(function (EpicSearchSortBy) {
    EpicSearchSortBy["LOCATION"] = "location";
})(EpicSearchSortBy || (EpicSearchSortBy = {}));
export class EpicSearchSortByOptsDto {
}
__decorate([
    IsArray(),
    IsString({ each: true })
], EpicSearchSortByOptsDto.prototype, "locationZipcodes", void 0);
export class EpicSearchFiltersDto {
}
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], EpicSearchFiltersDto.prototype, "locations", void 0);
__decorate([
    IsOptional(),
    IsEnum(EpicSearchSortBy)
], EpicSearchFiltersDto.prototype, "sortBy", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => EpicSearchSortByOptsDto)
], EpicSearchFiltersDto.prototype, "sortByOpts", void 0);
export class EpicSearchCursorDto {
}
__decorate([
    IsNumber()
], EpicSearchCursorDto.prototype, "lastIndex", void 0);
__decorate([
    IsNumber()
], EpicSearchCursorDto.prototype, "pageSize", void 0);
export class EpicSearchInputDto {
}
__decorate([
    IsString()
], EpicSearchInputDto.prototype, "search", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => EpicSearchCursorDto)
], EpicSearchInputDto.prototype, "cursor", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], EpicSearchInputDto.prototype, "isSandbox", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => EpicSearchFiltersDto)
], EpicSearchInputDto.prototype, "filters", void 0);
export class EpicSearchResultDto {
}
__decorate([
    IsString()
], EpicSearchResultDto.prototype, "id", void 0);
__decorate([
    IsString()
], EpicSearchResultDto.prototype, "name", void 0);
__decorate([
    IsString()
], EpicSearchResultDto.prototype, "url", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], EpicSearchResultDto.prototype, "score", void 0);
__decorate([
    IsOptional(),
    IsString()
], EpicSearchResultDto.prototype, "careFacilityName", void 0);
export class EpicSearchResultsWithCursorDto {
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => EpicSearchResultDto)
], EpicSearchResultsWithCursorDto.prototype, "results", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => EpicSearchCursorDto)
], EpicSearchResultsWithCursorDto.prototype, "nextCursor", void 0);
__decorate([
    IsNumber()
], EpicSearchResultsWithCursorDto.prototype, "totalHits", void 0);
export class EpicEndpointDto {
}
__decorate([
    IsString()
], EpicEndpointDto.prototype, "name", void 0);
__decorate([
    IsString()
], EpicEndpointDto.prototype, "url", void 0);
